var _ = require('lodash');

_.mixin({
    /**
     * @param string
     * @returns {string}
     */
    capitalize: function (string) {
        return string.charAt(0).toUpperCase() + string.substring(1).toLowerCase();
    },
    /**
     * Get query string param by name
     * window.location.search()
     *
     * @param name - String of param name
     * @return {string} value or empty string if not found
     */
    getQueryParamByName: function (name) {
        var regexS = '[\\?&]' + name + '=([^&#]*)';
        var regex = new RegExp(regexS);
        var results = regex.exec(window.location.search);
        if (results === null) {
            return '';
        } else {
            return decodeURIComponent(results[1].replace(/\+/g, ' '));
        }
    },
    /**
     * https://github.com/kvz/phpjs/blob/master/functions/url/urlencode.js
     * @param url
     * @return {string} encoded url
     */
    urlencode: function (str) {
        str = (str + '').toString();
        // Tilde should be allowed unescaped in future versions of PHP (as reflected below), but if you want to reflect current
        // PHP behavior, you would need to add '.replace(/~/g, '%7E');' to the following.
        return encodeURIComponent(str).replace(/!/g, '%21').replace(/'/g, '%27').replace(/\(/g, '%28').replace(/\)/g, '%29').replace(/\*/g, '%2A').replace(/%20/g, '+');
    },
    /**
     * Returns a copy of the object with these values removed: null, "", undefined
     *
     * @param o - object literal
     * @return {object} clone of o, with falsy values removed
     */
    compactObject: function (o) {
        var clone = _.clone(o);
        _.each(clone, function (v, k){
            if(_.isNull(v) || _.isUndefined(v) || (_.isString(v) && v.length === 0)){
                delete clone[k];
            }
        });
        return clone;
    },
    /**
     * Returns if the given parameter has a truthy value or not
     */
    checkIfTrue: function(val) {
        return [ 'true', '1', true, 1, 'yes' ].indexOf( val ) >= 0;
    }

});



// WEBPACK FOOTER //
// ./app/scripts/util/mixin.js